export const baseUrl = 'https://devx-api.jetboard.site'

export const defaultProfileImage =
  'https://zylk.s3.ap-south-1.amazonaws.com/organization4/common_profile_pic.jpg'
